module.exports = __webpack_public_path__ + "img/analytics-payment-bg-dark.7b0f3030.png";